<template>
    <div class="BoxWide">
        <div class="Filter">
            <input type="text" id="filtroSito" @change="this.updateUnita" style="display:none;">
            <form>
                <fieldset>
                    <legend>Filtra per:</legend>
                    <div class="FormRow">
                        <div class="FormBox25">
                            <label>Sito</label>
                            <select class="CustomSelect NoSearch" name="" id="selectSiti" >
                                <option value="all">Tutti</option>
                                <option v-for="(sito,index) in this.$store.getters.getSiti" :key="index" :value="sito.CodiceSito" >{{ sito.DescrizioneOperativa }}</option>
                            </select>
                        </div>                        
                        <div class="FormBox25">
                            <label>Unità</label>
                            <select class="CustomSelect NoSearch" name="" id="selectUnita">
                                <option value="all">Tutti</option>  
                                <option v-for="unita in this.listaUnitaFilterd" :key="unita.CodiceUnita" :value="unita.CodiceUnita">{{ unita.Descrizione }}</option>                                                       
                            </select>
                        </div>
                        <div class="FormBox25">
                            <label>Reparto</label>
                            <select class="CustomSelect NoSearch" name="" id="selectReparto">
                                <option value="all">Tutti</option>
                                <option v-for="(reparto,index) in this.$store.getters.getReparti" :key="index" :value="reparto.CodiceReparto">{{ reparto.DescrReparto }}</option>-->
                            </select>
                        </div>
                        <div class="FormBox25">
                            <label>Entità</label>
                            <select class="CustomSelect NoSearch" name="" id="selectEntita">
                                <option value="all">Tutti</option>
                                <option v-for="(entita,index) in this.$store.getters.getEntitaAsc" :key="index" :value="entita.CodiceEntita">{{ entita.Descrizione }}</option>                          
                            </select>
                        </div>
                    </div>
                    <div class="FormRow">
                        <div class="FormBox25">
                            <label>Data fino a</label>
                            <input type="date" id="" name="" placeholder="Inserisci la data" v-model="this.dataFinoASelected">
                        </div>
                        <div class="FormBox25">
                            <div class="TwinButtons">
                                <div class="Button ExtraSmall">
                                    <input type="button" id="" name="" value="Filtra" @click="this.filtraScadenzari()" />
                                </div>
                                <div class="Button ExtraSmall">
                                    <a href="javascript:void(0)" @click="this.rimuoviFiltri">Rimuovi filtri</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </form>
        </div>
    </div>
</template>

<script>

import FiltroModelliScadenzario from "@/models/filtroModelliScadenzario.model.js";

export default {
    name: "FiltroScadenzario",
    data(){
        return {
            sitoSelected: "",
            repartoSelected: "",
            unitaSelected: "",
            entitaSelected: "" ,
            dataFinoASelected : "",
            filtroUnita: "",
            listaUnitaFilterd : []
        }
    },

    methods:{
        filtraScadenzari: function(){
            this.sitoSelected = $('#selectSiti').select2('data')[0].id;  
            this.entitaSelected = $('#selectEntita').select2('data')[0].id;   
            this.unitaSelected = $('#selectUnita').select2('data')[0].id;
            this.repartoSelected = $('#selectReparto').select2('data')[0].id;

            let filtroData  = new FiltroModelliScadenzario(this.sitoSelected, this.repartoSelected, this.unitaSelected, this.entitaSelected, this.dataFinoASelected);
            this.$emit("FiltraScadenzari", filtroData);
            
        },
        updateUnita: function(){
            let listaUnita = this.$store.getters.getUnita;
            let v =  $('#selectSiti').select2('data')[0].id; 
            this.listaUnitaFilterd = listaUnita.filter(item => {return item.CodiceSito === v});
        },

        rimuoviFiltri: function(){

            $('#selectSiti').val("all").trigger('change'); 
            $('#selectEntita').val("all").trigger('change');
            $('#selectUnita').val("all").trigger('change');
            $('#selectReparto').val("all").trigger('change');  


            this.sitoSelected= "all";
            this.entitaSelected= "all";
            this.entitaSelected= "all";
            this.repartoSelected= "all";

            this.$emit("RimuoviFiltri");           
        }
    },
    mounted: function(){
        $(document).ready(function() {
            $('.CustomSelect').select2({
                theme: "classic"
            });

            $('.CustomSelect').on('select2:select', function (e) {
                var codiceSito = e.params.data.id;             
                $("#sitoSelected").val(codiceSito);
            });

            $('.CustomSelect').on('select2:select', function (e) {
                var codiceEntita = e.params.data.id;             
                $("#entitaSelected").val(codiceEntita);
            });

            $('.CustomSelect').on('select2:select', function (e) {
                var codiceUnita = e.params.data.id;             
                $("#entitaSelected").val(codiceUnita);
            }); 
            
            $('.CustomSelect').on('select2:select', function (e) {
                var codiceReparto = e.params.data.id;             
                $("#repartoSelected").val(codiceReparto);
            });

            $("#selectSiti").on('select2:select', function (e) {  
                document.getElementById("filtroSito").dispatchEvent(new Event('change'));            
            }); 
        });
    }
};
</script>

<style>
input[type="date"]{-webkit-appearance:none;appearance:none;}
input[type="date"]{width:100%;}
input[type="date"]{background-color:#ffffff;border:1px solid #cccccc;box-shadow:0 0 6px 0 rgba(0,0,0,0.00) inset;border-radius:0;font-family:'Open Sans', sans-serif;font-size:13px;color:#252525;}
input[type="date"]{height:36px;padding-top:3px;padding-right:12px;padding-bottom:3px;padding-left:12px;}npm 
input[type="date"]:focus{border-color:#e10712;box-shadow:0 0 6px 0 rgba(0,0,0,0.00) inset;}
</style>